/**
 * Mirrors leads-service `UpdateLeadRequest` (`max:255`) and the `varchar(255)`
 * columns behind it. The API is the source of truth; these caps only stop the
 * request from being sent at all.
 *
 * All three inputs (name, email, company) previously passed `max={128}`, which is
 * the HTML attribute for numeric/date inputs and does nothing on text/email
 * fields — so a 263-character name reached the server and came back 422.
 */
export const MAX_LEAD_TEXT_FIELD_LENGTH = 255;
